exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-photo[data-v-5cfb4b8d] {\n    width: 2rem;\n    height: 2rem;\n    margin: -.375rem 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./resources/assets/js/components/Navbar.vue?vue&type=style&index=0&id=5cfb4b8d&scoped=true&lang=css&
// module id = Zj8e
// module chunks = 58